module.exports = __webpack_public_path__ + "img/trip(9).d207ff08.webp";